import { isObjectEmpty } from '../utils/object-helpers';

export default class LoginCheckoutService {
  private LOGIN_CHECKOUT_DATA_STORAGE_KEY = 'loginModalStoreData';

  public setCheckoutData(storeData) {
    if (storeData && !isObjectEmpty(storeData)) {
      localStorage.setItem(this.LOGIN_CHECKOUT_DATA_STORAGE_KEY, JSON.stringify(storeData));
    }
  }

  public getCheckoutData() {
    return localStorage.getItem(this.LOGIN_CHECKOUT_DATA_STORAGE_KEY);
  }

  public clearCheckoutData() {
    localStorage.removeItem(this.LOGIN_CHECKOUT_DATA_STORAGE_KEY);
  }
}
